import { flatMap, isArray } from 'lodash'

// Per-item errors of list fields arrive as { "<index>": messages }; flatten them into messages naming the item (1-based)
export function flattenListErrors(value: string[] | { [index: string]: string[] }): string[] {
  if (isArray(value)) return value
  return flatMap(value, (messages, index) => messages.map(message => `Item ${Number(index) + 1}: ${message}`))
}
